import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Table } from "semantic-ui-react";
import {formatCrypto, formatPercent, formatPercentN} from "../utils/numberFormat";
import { formatDateTimeFromApi } from "../utils/dateTime";
import { BNB_FEE_FRACTION } from "../utils/botUtils";

@inject("store")
@observer
class XTradesTable extends Component {
  render() {
    const {
      xTrades,
      open,
      totalAmount,
      counterCurrency,
      headerText,
      store: { zoneId },
    } = this.props;

    const xTradesRows = xTrades.map((t, i) => {
      const feeTotal = t.feeCurrencyCode === counterCurrency ? t.feeTotal : t.feeTotal * t.price;
      const feeAmount = open ? 0 : t.amount * feeTotal / t.totalPrice;

      return (
        <Table.Row key={"" + i}>
          <Table.Cell>{t.orderId}</Table.Cell>
          <Table.Cell>{formatCrypto(t.amount)}</Table.Cell>
          <Table.Cell>{formatPercent((t.amount + feeAmount) / totalAmount)}</Table.Cell>
          <Table.Cell>{formatCrypto(t.price)}</Table.Cell>
          <Table.Cell>{formatCrypto(t.totalPrice)}</Table.Cell>
          <Table.Cell>
            {formatCrypto(t.feeTotal)} {t.feeCurrencyCode} ({formatPercentN(
              t.feeCurrencyCode === "BNB" ? BNB_FEE_FRACTION : t.feeTotal / t.totalPrice,
              3
            )})
          </Table.Cell>
          <Table.Cell>{formatDateTimeFromApi(t.date, zoneId)}</Table.Cell>
        </Table.Row>
      );
    });

    return (
      <div>
        <b>{headerText}</b>
        <Table celled unstackable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Order ID</Table.HeaderCell>
              <Table.HeaderCell>Amount</Table.HeaderCell>
              <Table.HeaderCell>Amount % of Total</Table.HeaderCell>
              <Table.HeaderCell>Price</Table.HeaderCell>
              <Table.HeaderCell>Total</Table.HeaderCell>
              <Table.HeaderCell>Fee (% from Total)</Table.HeaderCell>
              <Table.HeaderCell>Date</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>{xTradesRows}</Table.Body>
        </Table>
      </div>
    );
  }
}

export default XTradesTable;



// WEBPACK FOOTER //
// ./src/trade/XTradesTable.js